import React from 'react';

export const KIDDIE = 'kiddie';
export const MIDDLE = 'middle';
export const TEACHER = 'teacher';

export function ScopeStyles({ children, styleKey }) {
  const classes = ['ScopeStyles'];
  if (styleKey) {
    classes.push(`ScopeStyles--${styleKey}`);
  }

  return <div className={classes.join(' ')}>{children}</div>;
}
